import { initSentry } from './lib/sentry';

// Sentry DEVE ser inicializado antes de qualquer outro código
initSentry();

// Registra no console se String/Number.prototype.toString forem sobrescritos
// (ver comentário no módulo). Cedo, para pegar quem fizer isso durante o boot.
import { installPrototypeIntegrityGuard } from './lib/prototypeIntegrityGuard';
installPrototypeIntegrityGuard();

import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { getInitialTheme, applyThemeToDOM } from './hooks/shared/useTheme'

// Inicializar tema antes de renderizar o App para que a splash screen já apareça com o tema correto
const initialTheme = getInitialTheme();
applyThemeToDOM(initialTheme);

// Garantir título da guia sem valores indesejados (ex.: 1905)
document.title = 'Vertto CRM';

// Após um deploy, chunks dinâmicos antigos somem da CDN. O Vite emite
// `vite:preloadError` antes do import() rejeitar — recarregamos com
// cache-bust para pegar o index.html novo (e os hashes novos).
// Usa o mesmo contador `_recovery` que o lazyWithRetry: 0 → mesma URL,
// 1 → home, 2 → desiste (deixa o lazyWithRetry/ErrorBoundary cuidar).
window.addEventListener('vite:preloadError', (event) => {
  const url = new URL(window.location.href);
  const recoveryStep = Number(url.searchParams.get('_recovery') || '0');
  if (recoveryStep >= 2) return;

  const reloadKey = 'vite_preload_reload_at';
  const last = Number(sessionStorage.getItem(reloadKey) || 0);
  if (Date.now() - last <= 30_000) return;

  sessionStorage.setItem(reloadKey, String(Date.now()));
  event.preventDefault();

  let targetUrl: URL;
  if (recoveryStep === 0) {
    targetUrl = new URL(window.location.href);
    targetUrl.searchParams.set('_cb', Date.now().toString());
    targetUrl.searchParams.set('_recovery', '1');
  } else {
    targetUrl = new URL('/', window.location.origin);
    targetUrl.searchParams.set('_cb', Date.now().toString());
    targetUrl.searchParams.set('_recovery', '2');
  }
  window.location.replace(targetUrl.toString());
});

createRoot(document.getElementById("root")!).render(<App />);
